// extracted by mini-css-extract-plugin
export default {"root":"GetStarted_root__MtL9S","steps":"GetStarted_steps__2ALzS","complete":"GetStarted_complete__t5u2W","disabled":"GetStarted_disabled__p6S19"};